import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { NotificationService } from "../services/notification.service";
import { INTERCEPTOR_FAIL } from "constants/notifications.constants";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private readonly notificationService = inject(NotificationService);

  // intercept(req: HttpRequest<any>, next: HttpHandler) {
  //   // Get the auth token from the service.

  //   // send cloned request with header to the next handler.
  //   return next.handle(authReq);
  // }

  public intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(httpRequest).pipe(
      // TODO: Better error handling, e.g. let components recoverably handle errors from API services
      catchError((error: HttpErrorResponse) => {
        let errorMsg = null;
        if (error.error instanceof ErrorEvent) {
          errorMsg = error.error.message;
          this.notificationService.displayError(errorMsg);
        } else if (error.status === 0 || error.status === HttpStatusCode.GatewayTimeout) {
          // Status 0 means the network could not be reached.
          // Status 504 Gateway Timeout also means that Inseer could not be reached.
          this.notificationService.displayError(INTERCEPTOR_FAIL.INTERNET_CONNECTION);
        } else if (error.status === HttpStatusCode.InternalServerError) {
          const message = error.error.toString() as string;
          this.notificationService.displayError(
            INTERCEPTOR_FAIL.SERVER_ERROR,
            INTERCEPTOR_FAIL.SERVER_ERROR_TITLE,
            { enableHtml: true, messageClass: "styled-message" }
          );
        } else if (error.status === HttpStatusCode.BadRequest) {
          // Status 400: Bad request
          this.notificationService.displayError(
            INTERCEPTOR_FAIL.BAD_REQUEST,
            INTERCEPTOR_FAIL.BAD_REQUEST_TITLE,
            { enableHtml: true, messageClass: "styled-message" }
          );
        } else if (error.status === HttpStatusCode.Forbidden) {
          // Status 403: Forbidden
          this.notificationService.displayError(
            INTERCEPTOR_FAIL.FORBIDDEN,
            INTERCEPTOR_FAIL.FORBIDDEN_TITLE
          );
        }
        console.error(errorMsg ?? "Unknown error!");
        return throwError(() => error);
      })
    );
  }
}
